@if (service.collapsedItems().length > 0) {
  <div #breadcrumbItem class="tt-taxonomy-breadcrumb_item">
    {{ service.visibleItems()[0].label ? (service.visibleItems()[0].label | transloco) : service.visibleItems()[0].value }}
    <mat-icon class="tt-taxonomy-breadcrumb_icon" [icon]="'toc-chevron-right'" [iconSize]="12" />
    <span class="tt-taxonomy-breadcrumb_item-tooltip" [ttTooltip]="service.collapsedItems() | taxonomyTreeToText">...</span>
    <mat-icon class="tt-taxonomy-breadcrumb_icon" [icon]="'toc-chevron-right'" [iconSize]="12" />
    {{ service.visibleItems()[1].label ? (service.visibleItems()[1].label | transloco) : service.visibleItems()[1].value }}
  </div>
} @else {
  <div #breadcrumbItem class="tt-taxonomy-breadcrumb_item">
    @for (visibleItem of service.visibleItems(); track visibleItem.value) {
      {{ visibleItem.label ? (visibleItem.label | transloco) : visibleItem.value }}
      @if (!$last) {
        <mat-icon class="tt-taxonomy-breadcrumb_icon" [icon]="'toc-chevron-right'" [iconSize]="12" />
      }
    }
  </div>
}
